import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { Button, ButtonColorType, ButtonSizeType, ButtonVariantType } from "@website/ui/button";
import { numberConvert } from "@website/utils/number-convert";
import { CheckboxFilter, Input, RadioFilter, RangeFilter, SwitchFilter } from "@website/widget/filter/filter-components";
import { FilterMap } from "@website/widget/filter/filter-map";
import { useCityFilterState, useFilterLayoutEffect, useFilterTracking, useFilters } from "@website/widget/filter/filter.hook";
import type { FiltersSchemaType, MapFilterProperties } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import { useHandleScroll } from "@website/widget/filter/scroll.hook";
import { Children, Fragment, useRef } from "react";
interface ResetButtonProperties {
  size: ButtonSizeType;
  color: ButtonColorType;
  variant: ButtonVariantType;
}
interface FilterProperties {
  schema: FiltersSchemaType;
  title: string;
  loading?: boolean;
  filtersActionTitle: string;
  resetButtonProps: ResetButtonProperties;
  className?: string;
  filtersClassName?: string;
  mapFilterProps?: MapFilterProperties;
  scroll?: boolean;
  trackingCallback?({
    removed
  }: {
    removed: object;
  }): void;
  dontSyncScroll?: boolean;
}
export const Filters = properties => {
  const $ = _c(75);
  const {
    schema,
    loading,
    title,
    filtersActionTitle,
    resetButtonProps,
    className,
    filtersClassName,
    mapFilterProps,
    scroll,
    trackingCallback,
    dontSyncScroll
  } = properties;
  const containerReference = useRef(null);
  const {
    isMobile
  } = useViewPort();
  let t0;
  if ($[0] !== dontSyncScroll) {
    t0 = {
      dontSyncScroll
    };
    $[0] = dontSyncScroll;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    formRef
  } = useFilterLayoutEffect(t0);
  let t1;
  if ($[2] !== schema) {
    t1 = {
      schema
    };
    $[2] = schema;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    selectedFiltersCount,
    filterKeys,
    clearFilters
  } = useFilters(t1);
  const {
    onCloseFilters,
    visible
  } = useCityFilterState();
  let t2;
  if ($[4] !== filterKeys || $[5] !== scroll) {
    t2 = {
      scroll,
      containerReference,
      filterKeys
    };
    $[4] = filterKeys;
    $[5] = scroll;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useHandleScroll(t2);
  let t3;
  if ($[7] !== schema || $[8] !== trackingCallback) {
    t3 = {
      callback: trackingCallback,
      schema
    };
    $[7] = schema;
    $[8] = trackingCallback;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useFilterTracking(t3);
  let t4;
  if ($[10] !== schema) {
    t4 = Object.entries(schema);
    $[10] = schema;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const filtersSchemaEntries = t4;
  let t10;
  let t11;
  let t12;
  let t13;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[12] !== className || $[13] !== clearFilters || $[14] !== filtersClassName || $[15] !== filtersSchemaEntries || $[16] !== formRef || $[17] !== isMobile || $[18] !== mapFilterProps || $[19] !== onCloseFilters || $[20] !== resetButtonProps || $[21] !== selectedFiltersCount || $[22] !== title || $[23] !== visible) {
    const children = filtersSchemaEntries.map(_temp).filter(Boolean);
    t10 = `${styles["panel-container"]} ${visible ? styles.visible : ""} ${className ?? ""}`;
    t11 = visible && isMobile ? "dialog" : undefined;
    t12 = containerReference;
    if ($[33] !== mapFilterProps) {
      t13 = mapFilterProps && <FilterMap label={mapFilterProps.label} onClick={mapFilterProps.onClick} />;
      $[33] = mapFilterProps;
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    t8 = `${styles.filters} ${filtersClassName ?? ""}`;
    let t14;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <MaterialIcon className="text-on-surface-medium-emphasis text-2xl" name="arrow_forward" />;
      $[35] = t14;
    } else {
      t14 = $[35];
    }
    let t15;
    if ($[36] !== onCloseFilters) {
      t15 = <Button className={styles["close-button"]} color="neutral" onClick={onCloseFilters} variant="text">{t14}</Button>;
      $[36] = onCloseFilters;
      $[37] = t15;
    } else {
      t15 = $[37];
    }
    let t16;
    if ($[38] !== title) {
      t16 = <span className={styles["filters-header-title"]}>{title}</span>;
      $[38] = title;
      $[39] = t16;
    } else {
      t16 = $[39];
    }
    let t17;
    if ($[40] !== t15 || $[41] !== t16) {
      t17 = <div className={styles["filters-title-container"]}>{t15}{t16}</div>;
      $[40] = t15;
      $[41] = t16;
      $[42] = t17;
    } else {
      t17 = $[42];
    }
    let t18;
    if ($[43] !== selectedFiltersCount) {
      t18 = Number(selectedFiltersCount) ? <MaterialIcon name="delete_outline" /> : null;
      $[43] = selectedFiltersCount;
      $[44] = t18;
    } else {
      t18 = $[44];
    }
    const t19 = !selectedFiltersCount;
    let t20;
    if ($[45] !== selectedFiltersCount) {
      t20 = selectedFiltersCount ? `حذف فیلترها (${numberConvert(selectedFiltersCount, {
        locale: "fa"
      })})` : "\u062D\u0630\u0641 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627";
      $[45] = selectedFiltersCount;
      $[46] = t20;
    } else {
      t20 = $[46];
    }
    let t21;
    if ($[47] !== clearFilters || $[48] !== resetButtonProps || $[49] !== t18 || $[50] !== t19 || $[51] !== t20) {
      t21 = <Button {...resetButtonProps} StartIcon={t18} className="h-16" hidden={t19} onClick={clearFilters}>{t20}</Button>;
      $[47] = clearFilters;
      $[48] = resetButtonProps;
      $[49] = t18;
      $[50] = t19;
      $[51] = t20;
      $[52] = t21;
    } else {
      t21 = $[52];
    }
    if ($[53] !== t17 || $[54] !== t21) {
      t9 = <div className={styles["filters-header-box"]}>{t17}{t21}</div>;
      $[53] = t17;
      $[54] = t21;
      $[55] = t9;
    } else {
      t9 = $[55];
    }
    t5 = styles["filters-form-container"];
    t6 = formRef;
    t7 = Children.map(children, (child, index) => <Fragment key={child?.key ?? index}>{child}{Children.count(children) - 1 !== index && <div className={styles.divider} />}</Fragment>);
    $[12] = className;
    $[13] = clearFilters;
    $[14] = filtersClassName;
    $[15] = filtersSchemaEntries;
    $[16] = formRef;
    $[17] = isMobile;
    $[18] = mapFilterProps;
    $[19] = onCloseFilters;
    $[20] = resetButtonProps;
    $[21] = selectedFiltersCount;
    $[22] = title;
    $[23] = visible;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t10 = $[24];
    t11 = $[25];
    t12 = $[26];
    t13 = $[27];
    t5 = $[28];
    t6 = $[29];
    t7 = $[30];
    t8 = $[31];
    t9 = $[32];
  }
  let t14;
  if ($[56] !== t5 || $[57] !== t6 || $[58] !== t7) {
    t14 = <div className={t5} ref={t6}>{t7}</div>;
    $[56] = t5;
    $[57] = t6;
    $[58] = t7;
    $[59] = t14;
  } else {
    t14 = $[59];
  }
  let t15;
  if ($[60] !== filtersActionTitle || $[61] !== loading || $[62] !== onCloseFilters) {
    t15 = <div className={styles["filters-footer-container"]}><Button color="secondary" fullWidth={true} loading={loading} onClick={onCloseFilters} size="large">{filtersActionTitle}</Button></div>;
    $[60] = filtersActionTitle;
    $[61] = loading;
    $[62] = onCloseFilters;
    $[63] = t15;
  } else {
    t15 = $[63];
  }
  let t16;
  if ($[64] !== t14 || $[65] !== t15 || $[66] !== t8 || $[67] !== t9) {
    t16 = <div className={t8}>{t9}{t14}{t15}</div>;
    $[64] = t14;
    $[65] = t15;
    $[66] = t8;
    $[67] = t9;
    $[68] = t16;
  } else {
    t16 = $[68];
  }
  let t17;
  if ($[69] !== t10 || $[70] !== t11 || $[71] !== t12 || $[72] !== t13 || $[73] !== t16) {
    t17 = <aside className={t10} role={t11} ref={t12}>{t13}{t16}</aside>;
    $[69] = t10;
    $[70] = t11;
    $[71] = t12;
    $[72] = t13;
    $[73] = t16;
    $[74] = t17;
  } else {
    t17 = $[74];
  }
  return t17;
};
function _temp(t0) {
  const [name, schema_0] = t0;
  switch (schema_0.type) {
    case "range":
      {
        return <RangeFilter key={name} {...schema_0} />;
      }
    case "input":
      {
        return <Input key={name} name={name} {...schema_0} />;
      }
    case "switch":
      {
        return <SwitchFilter key={name} name={name} {...schema_0} />;
      }
    case "radio":
      {
        return <RadioFilter key={name} name={name} {...schema_0} />;
      }
    case "checkbox":
      {
        return <CheckboxFilter key={name} name={name} {...schema_0} />;
      }
    case "custom":
      {
        return <Fragment key={name}>{schema_0.component}</Fragment>;
      }
    default:
      {
        return null;
      }
  }
}